import {ref} from 'vue';

type SnackbarColor = 'success' | 'warning' | 'error' | 'info';

interface Snackbar {
  id: number;
  color: SnackbarColor;
  text: string;
  /** Present for API compatibility; snackbar chrome may toggle visibility elsewhere */
  enabled: boolean;
}

class SnackbarService {
  snackbars = ref<Snackbar[]>([]);

  private nextId = 0;
  private readonly timeouts = new Map<number, ReturnType<typeof setTimeout>>();

  showHappySnackbar(message: string) {
    this._showSnackbar('success', message);
  }

  showSadSnackbar(message: string) {
    this._showSnackbar('error', message);
  }

  showStatusSnackbar(type: SnackbarColor, message: string) {
    this._showSnackbar(type, message);
  }

  private _showSnackbar(color: SnackbarColor, message: string) {
    const id = ++this.nextId;
    this.snackbars.value.push({id, color, text: message, enabled: true});
    const timeoutId = setTimeout(() => {
      this.removeSnackbarById(id);
    }, 4000);
    this.timeouts.set(id, timeoutId);
  }

  private removeSnackbarById(id: number) {
    const timeoutId = this.timeouts.get(id);
    if (timeoutId !== undefined) {
      clearTimeout(timeoutId);
      this.timeouts.delete(id);
    }
    const idx = this.snackbars.value.findIndex(s => s.id === id);
    if (idx !== -1) {
      this.snackbars.value.splice(idx, 1);
    }
  }

  toggleSnackbarOff(index: number) {
    const item = this.snackbars.value[index];
    if (!item) {
      return;
    }
    this.removeSnackbarById(item.id);
  }
}

export default new SnackbarService();
